@if (product) {
  @if (
    {
      productPriceDisplay: productPrice?.current / 100 | currency: ' ' : 'code' : '1.0-0' : 'fr-CH',
      originalPriceDisplay:
        originalPrice?.current / 100 | currency: ' ' : 'code' : '1.0-0' : 'fr-CH',
    };
    as vm
  ) {
    <!-- old design -->
    @if (!productAlternativeUI) {
      <div class="product-best-value-wrapper">
        <div
          class="product-best-value"
          [class]="platform + '-background alternative'"
          [innerHTML]="
            isBestValue
              ? (bestValueTranslation | translate)
              : isApprenticeship
                ? ('PRODUCT_OFFERING.APPRENTICESHIP_OFFER' | translate)
                : ''
          "
        ></div>
      </div>
      <div
        class="card"
        [class]="platform + '-border alternative'"
        [class.product-best-value-card-background]="isBestValue || isApprenticeship"
      >
        <section>
          <span class="product-title title-s">{{ product.name | translate }}</span>
          @if (calendarFeature) {
            <div class="calendar-feature-wrapper">
              <ui-product-calendar-label
                [productCode]="product.code"
                [title]="calendarFeature.translation"
              />
              @if (calendarFeature.description) {
                <ui-product-tooltip [text]="calendarFeature.description" />
              }
            </div>
          }
        </section>
        @if (!isCollapsed) {
          @if (!productAlternativeUI) {
            <div class="product-description body-s">
              {{ product.description | translate }}
              @if (product.code | descriptionNotePipe) {
                <span>
                  {{ 'PRODUCT_OPTIONS.PRODUCT.DESCRIPTION_JOBSOFFER22FREE_NOTE' | translate }}
                </span>
              }
            </div>
          }
          <section>
            <!-- if new ui free products and benefits removed-->
            @if (productAlternativeUI) {
              <span>
                @if (discountLineThrough && originalPrice?.current > productPrice?.current) {
                  <span class="product-discount-label product-discount-label-ui-desktop">
                    {{ 'PRODUCT_OFFERING.ONE_TIME_DISCOUNT' | translate }}
                  </span>
                } @else {
                  <span>&nbsp;</span>
                }
                <span class="product-price title-s">
                  <span class="nobold"
                    >{{ originalPrice?.currency }}
                    {{ vm.originalPriceDisplay }}
                    <!-- discount price -->
                    @if (discountLineThrough && originalPrice?.current > productPrice?.current) {
                      <span class="product-price-line-through">
                        {{ originalPrice?.currency }}
                        {{ vm.originalPriceDisplay }}
                      </span>
                    }
                    <!--  end discount price -->
                  </span>
                </span>
              </span>
            } @else {
              @if (discountLineThrough && originalPrice?.current > productPrice?.current) {
                <span class="product-discount-label">
                  {{ 'PRODUCT_OFFERING.ONE_TIME_DISCOUNT' | translate }}
                </span>
              } @else {
                <span>&nbsp;</span>
              }
              <span class="product-price title-s">
                <span class="nobold">{{ productPrice?.currency }} </span>
                {{ vm.productPriceDisplay }}
                <!-- discount price -->
                @if (discountLineThrough && originalPrice?.current > productPrice?.current) {
                  <span class="product-price-line-through">
                    {{ originalPrice?.currency }}
                    {{ vm.originalPriceDisplay }}
                  </span>
                }
                <!--  end discount price -->
              </span>
            }
            <div class="product-visibility mobile-only">
              <span class="product-visibility-text body-xs"
                >{{ 'PRODUCT_OFFERING.VISIBILITY' | translate }}:</span
              >
              <div class="platform-list">
                @for (platform of platformMapping; track platform) {
                  <ui-product-platform-cell [platform]="platform" />
                }
              </div>
            </div>
            <mkp-explain-benefits-wrapper
              [product]="product"
              [isReadMode]="isReadMode"
              (handleSelectProduct)="handleSelectedProduct.emit(product.code)"
            >
              <ui-button
                class="product-details-btn"
                [config]="productDetailsConfig"
                [mkpDataTest]="'product-details-cta-' + product.code"
                [trackingValue]="product.code"
                [translate]="'PRODUCT_OFFERING.PRODUCT_DETAILS'"
              />
            </mkp-explain-benefits-wrapper>
          </section>
        }
        @if (!isReadMode) {
          <ui-button
            class="select-btn"
            mkpDataTest="select-cta-btn"
            [loading]="isLoading"
            [config]="selectConfig"
            [translate]="'PRODUCT_OFFERING.SELECT_PLAN'"
            (click)="handleSelectedProduct.emit(product.code)"
          />
        }
      </div>
    } @else {
      <div class="product-best-value-wrapper">
        <div
          class="product-best-value"
          [class]="platform + '-background alternative'"
          [innerHTML]="
            isBestValue
              ? (bestValueTranslation | translate)
              : isApprenticeship
                ? ('PRODUCT_OFFERING.APPRENTICESHIP_OFFER' | translate)
                : ''
          "
        ></div>
      </div>
      <div
        class="card"
        [class]="platform + '-border alternative'"
        [class.product-best-value-card-background]="isBestValue || isApprenticeship"
      >
        <section>
          <span class="product-title title-s" [class.apprenticeship]="isApprenticeship">{{
            product.name | translate
          }}</span>
        </section>
        <section class="product-performance">
          @if (isApprenticeship) {
            <ui-product-platform-cell [platform]="platform" />
            @if (platform === 'jobs') {
              <span class="alternative-font-xs">
                {{ 'PRODUCT_OFFERING.APPRENTICESHIP.JOBS_DESCRIPTION' | translate }}
              </span>
            } @else {
              <span class="alternative-font-xs">
                {{ 'PRODUCT_OFFERING.APPRENTICESHIP.JOBUP_DESCRIPTION' | translate }}
              </span>
            }
          } @else if (isLite) {
            <span class="product-price title-s">
              {{ product.code | performanceReachPipe | translate }}
              <br />
              <span class="alternative-font-xs">{{
                'PRODUCT_OFFERING.LITE.REACH_LABEL' | translate
              }}</span>
            </span>
          } @else if ((product.code | performanceReachPipe | translate)?.length > 0) {
            <span class="product-price title-s">
              {{ product.code | performanceReachPipe | translate }}
              <br />
              <span class="alternative-font-xs">{{ 'PERFORMANCE_REACH_LABEL' | translate }}</span>
            </span>
          }
        </section>
        @if (isLite) {
          <section>
            @let translatedLiteCalendar = 'PRODUCT_OFFERING.LITE.CALENDAR_DAYS' | translate;
            <div class="calendar-feature">
              <div
                class="calendar-feature-days"
                [uiTooltip]="liteTooltipTranslationKey | translate"
                showUnderline
              >
                {{ translatedLiteCalendar | productAlternativeDays }}
              </div>
              <div class="calendar-feature-type">
                {{ translatedLiteCalendar | productAlternativeType }}
              </div>
            </div>
          </section>
        } @else if (calendarFeature && calendarFeature.translation) {
          <section>
            @if (calendarFeature.translation | translate; as translatedCalendarFeature) {
              <div class="calendar-feature">
                <div class="calendar-feature-days">
                  {{ translatedCalendarFeature | productAlternativeDays }}
                </div>
                <div class="calendar-feature-type">
                  {{ translatedCalendarFeature | productAlternativeType }}
                </div>
              </div>
            }
          </section>
        }
        @if (!isCollapsed) {
          <section>
            @if (isApprenticeship) {
              <span class="product-price-line-through apprenticeship">
                {{ productPrice?.currency }} 650
              </span>
              <span class="product-price title-s apprenticeship">
                {{ productPrice?.currency }}
                {{ vm.productPriceDisplay }}
              </span>
            } @else {
              @if (discountLineThrough && originalPrice?.current > productPrice?.current) {
                <span class="product-discount-label product-discount-label-ui-desktop">
                  {{ 'PRODUCT_OFFERING.ONE_TIME_DISCOUNT' | translate }}
                </span>
              } @else {
                <span>&nbsp;</span>
              }
              <span class="product-price title-s">
                {{ productPrice?.currency }}
                {{ vm.productPriceDisplay }}
                <!-- discount price -->
                @if (discountLineThrough && originalPrice?.current > productPrice?.current) {
                  <span class="product-price-line-through">
                    {{ originalPrice?.currency }}
                    {{ vm.originalPriceDisplay }}
                  </span>
                }
                <!--  end discount price -->
                <br />
                &nbsp;
              </span>
              <div class="product-visibility mobile-only">
                <span class="product-visibility-text body-xs"
                  >{{ 'PRODUCT_OFFERING.VISIBILITY' | translate }}:</span
                >
                <div class="platform-list">
                  @for (platform of platformMapping; track platform) {
                    <ui-product-platform-cell [platform]="platform" />
                  }
                </div>
              </div>
            }
          </section>
        }
        @if (!isReadMode) {
          <ui-button
            mkpDataTest="select-cta-btn"
            [class]="platform + '-call-to-action select-btn'"
            [class.is-best-value-btn]="isBestValue || isApprenticeship"
            [loading]="isLoading"
            [config]="selectConfig"
            [translate]="'PRODUCT_OFFERING.SELECT_PLAN'"
            (click)="handleSelectedProduct.emit(product.code)"
          />
        }
        <br />
        <mkp-explain-benefits-wrapper
          [product]="product"
          [isReadMode]="isReadMode"
          (handleSelectProduct)="handleSelectedProduct.emit(product.code)"
        >
          <ui-button
            class="product-details-btn"
            [config]="productDetailsConfig"
            [mkpDataTest]="'product-details-cta-' + product.code"
            [trackingValue]="product.code"
            [translate]="'PRODUCT_OFFERING.PRODUCT_DETAILS_ALTERNATIVE'"
          />
        </mkp-explain-benefits-wrapper>
      </div>
    }
  }
}
